export default __webpack_public_path__ + "static/media/KeyObservationsWithoutEdit.00e55975.png";